import React, { useState, useEffect } from "react";
import { TextInput } from "../../Components/Inputs";
import init_customer from "../init_customer";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useForm from "../../Components/hooks/useForm";

const EditCustomer = () => {
  const [input, setInput] = useState(init_customer);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const request = useAxios();
  const { id } = useParams();

  useEffect(() => {
    getCustomerDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getCustomerDetails() {
    let res = await request({
      method: "get",
      url: "customers/single-customer",
      params: { id: parseInt(id) },
    });
    if (res === "error") return;

    const inputCpy = { ...init_customer };
    inputCpy.name.value = res?.name || "";
    inputCpy.company_name.value = res?.company_name || "";
    inputCpy.email.value = res?.email || "";
    inputCpy.phone_no.value = res?.phone_no || "";
    inputCpy.address.value = res?.address || "";
    setInput(inputCpy);
  }

  const handleSubmit = async (data) => {
    setIsLoading(true);
    let res = await request({
      method: "PUT",
      url: `customers/update/${id}`,
      body: { ...data },
      show_loading: true,
      loadingFunc: setIsLoading,
    });

    if (res !== "error") {
      navigate("/dashboard/customers");
    }
  };

  const { handleValidation, validate } = useForm({
    input,
    submit: handleSubmit,
  });

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12 rounded-md">
      <h3 className="text-center text-2xl font-bold text-gray-700 mb-6">
        Edit Customer
      </h3>

      <TextInput
        input={input}
        setInput={setInput}
        field="name"
        validate={validate}
      />

      <TextInput
        input={input}
        setInput={setInput}
        field="company_name"
        validate={validate}
      />

      <div className="flex gap-5 items-center max-md:flex-col">
        <TextInput
          input={input}
          setInput={setInput}
          field="email"
          validate={validate}
        />
        <TextInput
          input={input}
          setInput={setInput}
          field="phone_no"
          validate={validate}
        />
      </div>

      <TextInput
        input={input}
        setInput={setInput}
        field="address"
        validate={validate}
      />

      <div className="mt-6 flex justify-between">
        <Btn onClick={() => navigate("/dashboard/customers")}>Back</Btn>
        <Btn onClick={handleValidation} disabled={isLoading}>
          {isLoading ? "Updating..." : "Submit"}
        </Btn>
      </div>
    </div>
  );
};

export default EditCustomer;
